import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map} from "rxjs/operators";
import {ADD_NOTE_ACTION, AddNoteActions} from "../actions/add-note-actions";
import {MatDialog} from "@angular/material/dialog";
import {AddNoteDialogComponent} from "../src/lib/dialogs/add-note-dialog/add-note-dialog.component";
import {Store} from "@ngrx/store";
// @ts-ignore
import {AppStore} from '@alfresco/aca-shared/store';

@Injectable()
export class AddNoteEffects {

  protected store = inject<Store<AppStore>>(Store<AppStore>);

  addNote$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<AddNoteActions>(ADD_NOTE_ACTION),
        map((action) => {
          this.openDialog(action);
        })
      ),
    {dispatch: false}
  );

  constructor(private actions$: Actions,
              private dialog: MatDialog
  ) {
  }


  openDialog(action): void {
    this.dialog.open(AddNoteDialogComponent, {data: action, width: '600px'});
  }
}
